import React, { useEffect, useMemo, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import axios from "../../../api/axiosService";
import FadeInSection from "../../../Components/FadeInSection";
import Skeleton from "../../../Components/Skeleton";
import { Tabs, ConfigProvider } from "antd";
import { sanitize, scrollToTop, getLocalized } from "../../../Common/Util";

const renderArticleSkeleton = (key) => (
  <div key={key} className="tab-content mb-12">
    <Skeleton.Text className="w-1/2 h-8 mx-auto mb-8" />
    <Skeleton className="w-full max-w-[960px] mx-auto h-[280px] md:h-[540px]" />
    <div className="my-4 mx-wrapper max-w-[960px] mx-auto w-full">
      <Skeleton text textLines={4} textClassName="h-4" />
    </div>
  </div>
);

const renderJourneyTabSkeleton = () => (
  <div className="tab-wrapper">
    {Array.from({ length: 2 }).map((_, index) =>
      renderArticleSkeleton(`journey-skeleton-${index}`),
    )}
  </div>
);

function About(props) {
  const { t, i18n } = useTranslation();
  const [journeyData, setJourneyData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const tabItems = useMemo(
    () => [
      {
        key: "1",
        label: <span className="normal-text">{t("HIGHLIGHTED_PROJECT")}</span>,
        children: isLoading ? (
          renderJourneyTabSkeleton()
        ) : (
          <div className="tab-wrapper">
            {journeyData
              .filter((d) => d.type === "highlighted")
              .map((airline) => (
                <div key={airline.id} className="tab-content mb-12">
                  <div className="flex items-center justify-center my-0 w-100">
                    <div className="title-with-lines">
                      <span className="inline-block px-4 text-center whitespace-normal md:whitespace-nowrap uppercase tracking-wider post-title-nw title-2">
                        {getLocalized(airline, "title", i18n.language)}
                      </span>
                    </div>
                    <div className="border-t border-gray-300 flex-grow"></div>
                  </div>

                  <div className="image-wrapper-journey my-4">
                    <img
                      src={airline.image}
                      alt={getLocalized(airline, "title", i18n.language)}
                      className="post-img object-cover"
                    />
                  </div>

                  <div className="my-4 normal-text-nw flex flex-col mx-wrapper">
                    <span
                      className="leading-relaxed text-justify normal-text"
                      dangerouslySetInnerHTML={sanitize(
                        getLocalized(airline, "description", i18n.language),
                      )}
                    />
                  </div>
                </div>
              ))}
          </div>
        ),
      },
      {
        key: "2",
        label: <span className="normal-text">{t("CSR_PROJECT")}</span>,
        children: isLoading ? (
          renderJourneyTabSkeleton()
        ) : (
          <div className="tab-wrapper">
            {journeyData
              .filter((d) => d.type === "csr")
              .map((airline) => (
                <div key={airline.id} className="tab-content mb-12">
                  <div className="flex items-center justify-center my-0 w-100">
                    <div className="title-with-lines">
                      <span className="px-4 text-center uppercase tracking-wider post-title-nw title-2 whitespace-normal md:whitespace-nowrap">
                        {getLocalized(airline, "title", i18n.language)}
                      </span>
                    </div>
                    <div className="border-t border-gray-300 flex-grow"></div>
                  </div>

                  <div className=" image-wrapper-journey my-4">
                    <img
                      src={airline.image}
                      alt={getLocalized(airline, "title", i18n.language)}
                      className="post-img object-cover"
                    />
                  </div>

                  <div className="my-4 normal-text-nw flex flex-col mx-wrapper">
                    <span
                      className="leading-relaxed text-justify normal-text"
                      dangerouslySetInnerHTML={sanitize(
                        getLocalized(airline, "description", i18n.language),
                      )}
                    />
                  </div>
                </div>
              ))}
          </div>
        ),
      },
    ],
    [isLoading, journeyData, t, i18n.language],
  );

  const getJourney = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get("/api/journey/list");
      setJourneyData(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getJourney();
  }, []);

  const onChange = () => {
    scrollToTop();
  };

  return (
    <div className="about-ssg">
      {/* Header section */}
      <div className="global-header-block-2">
        <FadeInSection direction="down">
          <div className="journey-text normal-text">{t("ABOUT_SSL")}</div>
          <h1 className="journey-title global-title-margin title-1">
            {" "}
            {t("SSL_JOURNEY")}
          </h1>
        </FadeInSection>
      </div>

      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#00C7B4",
          },
          components: {
            Tabs: {
              inkBarColor: "#00C7B4",
              itemActiveColor: "#00C7B4",
              itemHoverColor: "#000000",
              fontSize: "20px",
              gap: "20px",
            },
          },
        }}
      >
        <Tabs
          defaultActiveKey="1"
          items={tabItems}
          onChange={onChange}
          tabBarStyle={{
            fontWeight: 500,
            position: "sticky",
            top: 70,
            zIndex: 10,
            padding: "20px 0",
            backgroundColor: "#ffffff",
          }}
          className="custom-tabs"
        />
      </ConfigProvider>
    </div>
  );
}

export default About;
